import { Box, Button, Snackbar, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const InteractiveToastMessage = ({
	isOpen,
	message,
	actionButtonLabel,
	onClose,
	onAction,
}: {
	isOpen: boolean;
	message: string;
	actionButtonLabel: string;
	onClose: () => void;
	onAction: () => void;
}) => {
	const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}

		onClose();
	};

	return (
		<Snackbar
			open={isOpen}
			autoHideDuration={8000}
			anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
			ContentProps={{
				style: {
					background: "rgba(28, 49, 69, 0.9)",
				},
			}}
			style={{ maxWidth: "640px" }}
			message={
				<Alert
					icon={false}
					onClose={handleClose}
					variant="standard"
					style={{ background: "transparent", color: "white", padding: 0 }}
				>
					<Box display="flex" alignItems={"center"} width={"100%"}>
						<Typography>{message} </Typography>
						<Button
							style={{ marginLeft: "24px", borderColor: "#A4DEFF", color: "#A4DEFF", backgroundColor: "#37495a" }}
							variant="outlined"
							size="small"
							onClick={onAction}
						>
							{actionButtonLabel}
						</Button>
					</Box>
				</Alert>
			}
			onClose={handleClose}
		/>
	);
};

export default InteractiveToastMessage;
